import Model, { attr, hasMany } from '@ember-data/model';
import type CaffeinateCampaignSubscriptionModel from './caffeinate-campaign-subscription.ts';
import { Type } from '@warp-drive/core-types/symbols';

export default class CaffeinateCampaignModel extends Model {
  @attr declare name: string;
  @attr declare slug: string;
  @attr declare active: boolean;
  @attr declare createdAt: string;
  @attr declare updatedAt: string;

  @hasMany('caffeinate-campaign-subscription', { async: false, inverse: 'caffeinateCampaign' })
  declare caffeinateCampaignSubscriptions: CaffeinateCampaignSubscriptionModel[];

  [Type] = 'caffeinate-campaign' as const;
}
